import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectReviewsForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import CriticsReviews from './CriticsReviews';

export class CriticsReviewsContainer extends React.PureComponent {
  render() {
    return <CriticsReviews {...this.props} />;
  }
}

CriticsReviewsContainer.propTypes = {
  reviews: ImmutablePropTypes.list,
  totalReviews: PropTypes.number,
  catalogBib: catalogBibShape
};

const mapStateToProps = state => {
  const reviews = selectReviewsForCurrentBib(state);
  return {
    reviews: reviews.get('items'),
    totalReviews: reviews.get('totalReviews'),
    catalogBib: selectCatalogBib(state)
  };
};

export default connect(mapStateToProps)(CriticsReviewsContainer);
